const map = {
	"./Leiyingtao.png": 36561,
	"./back-home.png": 36263,
	"./banner.png": 24584,
	"./banner3.png": 3441,
	"./bg1.png": 33426,
	"./bg2.png": 81609,
	"./bg3.png": 57408,
	"./bg4.png": 85439,
	"./card-options-area-bg.png": 11975,
	"./check-circle.png": 62467,
	"./default-author.png": 21163,
	"./equipped-icon.png": 75995,
	"./icon1.png": 72572,
	"./icon2.png": 30679,
	"./icon3.png": 1454,
	"./icon4.png": 19169,
	"./icon5.png": 98040,
	"./lock-icon.png": 25265,
	"./story-bg.png": 67271,
	"./vip-icon.png": 75971
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57547;